/**
 * Frontend mirror of backend/src/core/auth/role-aliases.ts (2026-10-07, Veda
 * purchase tour bug 4). `purchase_manager` passes wherever `purchase` passes.
 *
 * 🔒 One-way, and only to `purchase` — never to `purchase_head`.
 * 🔒 KEEP IN SYNC with the backend table; the backend is the authority. This
 * exists so a screen does not hide a control the server would allow.
 * Compare LOWER-CASED names only.
 */
export const ROLE_ALIASES: Readonly<Record<string, readonly string[]>> = {
  purchase_manager: ['purchase'],
  // 2026-10-07 (Veda logistics tour bug 20): one-way aliases of logistics_manager.
  logistics_head: ['logistics_manager'],
  logistics: ['logistics_manager'],
};

/**
 * Lower-cased role name, with logistics_head / LOGISTICS folded to
 * logistics_manager. For screens that switch on ONE role name (menu, landing).
 */
export function asLogisticsRole(roleName: string | null | undefined): string {
  const r = (roleName ?? '').toLowerCase();
  return (ROLE_ALIASES[r] ?? []).includes('logistics_manager') ? 'logistics_manager' : r;
}

export function effectiveRoleNames(roleName: string | null | undefined): string[] {
  const r = (roleName ?? '').toLowerCase();
  return [r, ...(ROLE_ALIASES[r] ?? [])];
}

/** True when `roleName` (or a role it aliases) is in `allowedLower` (lower-cased). */
export function roleInList(
  roleName: string | null | undefined,
  allowedLower: ReadonlySet<string> | readonly string[],
): boolean {
  const list = allowedLower as ReadonlySet<string> & readonly string[];
  const has = (x: string) => (typeof (list as ReadonlySet<string>).has === 'function' ? (list as ReadonlySet<string>).has(x) : (list as readonly string[]).includes(x));
  return effectiveRoleNames(roleName).some(has);
}
